<template>
  <!-- 类名qs-ellipsis-tooltip不要删除 -->
  <div v-show-tooltip class="qs-ellipsis-tooltip wp100">
    <a-tooltip :content="sContent">
      <div
        class="overflow-ellipsis"
        :class="textClass"
        :style="{ '-webkit-line-clamp': line }"
      >
        {{ content }}
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  const props = defineProps({
    content: {
      type: [String, Number],
      default: '',
    },
    // 默认超过3行截断文本并提示
    line: {
      type: Number,
      default: 3,
    },
    textClass: {
      type: String,
      default: '',
    },
  });
  // 兼容content为数值型变量的情况
  const sContent = computed(() => {
    return props.content.toString();
  });
</script>

<script lang="ts">
  export default {
    // 用于文本超过多少行自动截断并且hover时tooltip提示
    name: 'EllipsisTooltip',
  };
</script>

<style lang="less" scoped>
  .overflow-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
</style>
